var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OverlayUIText',_vm._b({},'OverlayUIText',_vm.text,false)),_c('OverlayUIButton',_vm._b({on:{"click":_vm.buttonClick}},'OverlayUIButton',_vm.button,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }